import React, { forwardRef, PropsWithChildren } from "react";
import { createClasses } from "@bloomberg/media-ui-core";

import styles from "./gridLayout.module.css";

type PropsWithClassAndChildren = PropsWithChildren & {
    className?: string;
    name?: string;
    "data-position"?: string;
    id?: string;
};

const GridLayout = forwardRef<HTMLElement, PropsWithClassAndChildren>(
    ({ children, className, id, ...args }, ref) => {
        const cx = createClasses([styles.gridLayout, className]);
        return (
            <article className={cx} ref={ref} data-story-id={id} {...args}>
                {children}
            </article>
        );
    }
);

GridLayout.displayName = "GridLayout";

export default GridLayout;

export function GridLeftContent({
    children,
    className,
    ...args
}: PropsWithClassAndChildren) {
    const cx = createClasses([styles.leftContent, className]);
    return (
        <div className={cx} {...args}>
            {children}
        </div>
    );
}

export const GridCenterContent = forwardRef<
    HTMLDivElement,
    PropsWithClassAndChildren
>(({ children, className, name, ...args }, ref) => {
    const cx = createClasses([styles.centerContent, className]);
    return (
        <div className={cx} ref={ref} data-component={name} {...args}>
            {children}
        </div>
    );
});

GridCenterContent.displayName = "GridCenterContent";

export const GridFeatureCenterContent = forwardRef<
    HTMLDivElement,
    PropsWithClassAndChildren
>(({ children, className, ...args }, ref) => {
    const cx = createClasses([styles.featureCenterContent, className]);
    return (
        <div className={cx} ref={ref} {...args}>
            {children}
        </div>
    );
});

GridFeatureCenterContent.displayName = "GridFeatureCenterContent";

export function GridRightContent({
    children,
    className,
    ...args
}: PropsWithClassAndChildren) {
    const cx = createClasses([styles.rightContent, className]);
    return (
        <div className={cx} {...args}>
            {children}
        </div>
    );
}

export function GridTopContent({
    children,
    className,
    ...args
}: PropsWithClassAndChildren) {
    const cx = createClasses([styles.topContent, className]);
    return (
        <div className={cx} {...args}>
            {children}
        </div>
    );
}

export function GridFeatureTopContent({
    children,
    className,
    ...args
}: PropsWithClassAndChildren) {
    const cx = createClasses([styles.featureTopContent, className]);
    return (
        <div className={cx} {...args}>
            {children}
        </div>
    );
}

export function GridFull({
    children,
    className,
    name,
    ...args
}: PropsWithClassAndChildren) {
    const cx = createClasses([styles.full, className]);
    return (
        <div className={cx} data-component={name} {...args}>
            {children}
        </div>
    );
}
